export default "__VITE_ASSET__BGtiPFkR__"